import { Link } from 'react-router-dom';
import './SearchBar.css';
import searchButton from '../../img/search-button.svg';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const SearchBar = () => {

    let find = window.location.search;
    let params = new URLSearchParams(find);
    let searchQuery = params.get('search');

    const history = useHistory();
    const [searchInput, setSearchInput] = useState();

    const handleSearchClick = () => {
        history.push("/explore?search=" + searchInput);
        history.go(0);
    }

    const handleSearchKeyDown = (e) => {
        if(e.key === "Enter"){
            history.push("/explore?search=" + searchInput);
            history.go(0);
        }
    }

    const handleSearchInputChange = (e) => {
        setSearchInput(e.target.value);
    }

    return (
        <div className="searchbar-container">
            <div className="searchbar-inner-container">
                <input 
                    defaultValue={
                        searchQuery !== "undefined" ?
                        searchQuery
                        :
                        undefined
                    } 
                    onKeyDown={handleSearchKeyDown} 
                    id="searchbar-input" 
                    onChange={handleSearchInputChange} 
                    type="text" 
                    placeholder="Temukan barang yang ingin kamu cari disini...">
                </input>
                <a onClick={handleSearchClick} href="#" className="search-button"><img alt="Search" src={searchButton}></img></a>
            </div>
        </div>
    )
};

export default SearchBar;